import { Button } from '@leverege/ui-elements';
import React from 'react';
import { GlobalState } from '@leverege/ui-redux';
import S from './LinkCell.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LinkCellRenderer(data, props, context) {
  const {
    delegate,
    row: {
      original
    }
  } = data;
  const {
    renderer
  } = context;
  const output = renderer.renderCell(data, props, context);
  if (delegate.isGotoAllowed()) {
    let variant = output?.props?.variant;
    variant = variant ? `${variant}|linkTable` : 'linkTable';
    return /*#__PURE__*/_jsx(Button, {
      className: S.button,
      onClick: evt => {
        GlobalState.dispatch(delegate.goTo(original.id));
      },
      children: /*#__PURE__*/React.cloneElement(output, {
        variant
      })
    });
  }
  return output;
}